import {JORNADA_MADRUGADA, JORNADA_MAÑANA, JORNADA_TARDE, JORNADA_NOCHE} from './../../../constants/icons/characteristics/Characteristics';
import ReactDOMServer from 'react-dom/server';

/* export const dataneg =[
    {name: 'Page A', uv: 4000, female: 2400, male: 2400},
    {name: 'Page B', uv: 3000, female: 1398, male: 2210},
    {name: 'Page C', uv: -2000, female: 9800, male: 2290},
    {name: 'Page D', uv: 2780, female: 3908, male: 2000},
    {name: 'Page E', uv: 1890, female: 4800, male: 2181},
    {name: 'Page F', uv: 2390, female: -3800, male: 2500},
    {name: 'Page G', uv: 3490, female: 4300, male: 2100},
]
; */

export const data =[
    {name: 'Page A', uv: 4000, female: 2400, male: 2400},
    {name: 'Page B', uv: 3000, female: 1398, male: 2210},
    {name: 'Page C', uv: -2000, female: 9800, male: 2290},
    {name: 'Page D', uv: 2780, female: 3908, male: 2000},
    {name: 'Page E', uv: 1890, female: 4800, male: 2181},
    {name: 'Page F', uv: 2390, female: -3800, male: 2500},
    {name: 'Page G', uv: 3490, female: 4300, male: 2100},
]
;

export const svgs = [
    ReactDOMServer.renderToString(JORNADA_MADRUGADA), 
    ReactDOMServer.renderToString(JORNADA_MAÑANA), 
    ReactDOMServer.renderToString(JORNADA_TARDE), 
    ReactDOMServer.renderToString(JORNADA_NOCHE)
     
]
;

export const title = [
    'ABC'
]
;

export const name = [
    'grafica1'
]
;


export const colors = [
    '#1A171B', 
    '#003951', 
    '#006290',
    '#0070a1',
    '#038bc0', 
    '#29C1FC', 
    '#46BAE5', 
    '#73CBEB', 
    '#7DDBF4'
];

export const colors1 = [
    '#B71C1C', 
    '#C62828', 
    '#D32F2F',
    '#E53935',
    '#F44336', 
    '#EF5350', 
    '#E57373', 
    '#EF9A9A', 
    '#FFCDD2', 
    '#FFEBEE'
];

export const colors2 = [
    '#1A171B', 
    '#003951', 
    '#006290',
    '#0070a1',
    '#038bc0', 
    '#29C1FC', 
    '#46BAE5', 
    '#73CBEB', 
    '#7DDBF4'
];

export const colors3 = [
    '#1A171B', 
    '#003951', 
    '#006290',
    '#0070a1',
    '#038bc0', 
    '#29C1FC', 
    '#46BAE5', 
    '#73CBEB', 
    '#7DDBF4'
];
export const colors4 = [
    '#1A171B', 
    '#003951', 
    '#006290',
    '#0070a1',
    '#038bc0', 
    '#29C1FC', 
    '#46BAE5', 
    '#73CBEB', 
    '#7DDBF4'
];